module.exports = __webpack_public_path__ + "static/media/introo.5642ab9c.png";